import styled, { css } from 'styled-components'

import { mainColors, semanticColors } from '../../styles/colors'
import { _S_Medium } from '../../styles/typography'

const BaseMessageStyles = css`
  ${_S_Medium};
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 500px;

  > svg {
    width: 24px;
    height: 24px;
  }
`

export const MessageContainer = styled.div`
  ${BaseMessageStyles};
  color: ${semanticColors.successMedium};

  > svg {
    width: 24px;
    height: 24px;
  }
`

export const ErrorContainer = styled.div`
  ${BaseMessageStyles};
  color: ${semanticColors.failureMedium};
`

export const LoadingContainer = styled.div`
  ${BaseMessageStyles};
  margin-right: 16px;
  color: ${mainColors.neutralExtraDark};
`
